export default __webpack_public_path__ + "static/media/4_Still.48759c13.jpg";